<template>
  <section>
    <b-modal width="680px" :active.sync="isCardModalActive">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title">
            選択されたノードを削除しますがよろしいでしょうか？
          </p>
        </header>
        <div class="card-content">
          <p>
            <b-message type="is-danger" has-icon>
              削除されたノードは復元することはできません。
              削除したい箇所かどうか確認の上削除をお願いします。
            </b-message>
          </p>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="isCardModalActive=false">いいえ</a>
          <a class="card-footer-item" @click="clickDeleteNode()">はい</a>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ModalDeleteScnario',
  data () {
    return {
      isCardModalActive: false,
      scenarioDelete: null
    }
  },
  computed: {
    ...mapState('chatbot', ['scenarioTable', 'modalScenario', 'isModalDeleteNode', 'modalScenarioIndex']),
    ...mapState('auth', ['user'])
  },
  watch: {
    isModalDeleteNode () {
      this.isCardModalActive = this.isModalDeleteNode
    },
    isCardModalActive () {
      this.isCardModalActive ? console.log('isCardModalActive: true') : this.$store.dispatch('chatbot/closeModalScenario')
    }
  },
  methods: {
    clickDeleteNode () {
      console.debug('*** Start *** clickDeleteNode')
      this.scenarioDelete = this.modalScenario
      this.scenarioDelete.select[this.modalScenarioIndex].next_node = ''
      this.$store.dispatch('chatbot/setScenarioDemo', this.scenarioDelete)
      this.$store.dispatch('chatbot/closeModalScenario')
      this.isCardModalActive = false
      console.debug('*** End *** clickDeleteNode')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Top/ModalDeleteNodeDemo.vue